<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');

@import './assets/scss/base';

// transitions
.fade-enter-active {
    transition: opacity 350ms ease-in;
}
.fade-leave-active {
    transition: opacity 350ms ease-out;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.slide-up-enter-active {
    transition: all 350ms ease;
}
.slide-up-leave-active {
    transition: all 350ms ease;
    position: absolute;
}
.slide-up-move {
    transition: all 350ms ease;
}
.slide-up-enter,
.slide-up-leave-to {
    opacity: 0;
    transform: translate3d(0, 75%, 0);
}
</style>
